import * as Yup from "yup";

import { emailRegexp, nameSurnameRegexp, polishPhoneRegexp } from "../../../../regexps";
import i18n from "../../../../translations/i18n";

export const FormSchema = Yup.object().shape({
  supervisorName: Yup
    .string()
    .required(i18n.t("validationMessage.required"))
    .min(2, i18n.t("validationMessage.invalidName"))
    .max(50, i18n.t("validationMessage.invalidName"))
    .matches(nameSurnameRegexp, i18n.t("validationMessage.invalidName")),
  supervisorSurname: Yup
    .string()
    .required(i18n.t("validationMessage.required"))
    .matches(nameSurnameRegexp, i18n.t("validationMessage.invalidSurname"))
    .min(2, i18n.t("validationMessage.invalidSurname"))
    .max(128, i18n.t("validationMessage.invalidSurname")),
  supervisorEmail: Yup
    .string()
    .matches(emailRegexp, i18n.t("validationMessage.email"))
    .required(i18n.t("validationMessage.required")),
  email: Yup.string()
    .required(i18n.t("validationMessage.required")),
  phone: Yup.string()
    .matches(polishPhoneRegexp, i18n.t("validationMessage.phone"))
    .required(i18n.t("validationMessage.required")),
});
